import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Navdata = () => {
  const history = useNavigate();
  //state data
  const [isUsers, setIsUsers] = useState(false);
  const [isCurrentState, setIsCurrentState] = useState('');

  useEffect(() => {
    if (isCurrentState !== 'Users') {
      setIsUsers(false);
    }
  }, [history, isCurrentState, isUsers]);

  const menuItems = [
    {
      label: 'Menu',
      isHeader: true,
    },
    {
      id: 'dashboard',
      label: 'dashboard',
      icon: 'ri-dashboard-line',
      link: '/dashboard',
      click: function (e) {
        e.preventDefault();
        setIsCurrentState('Dashboard');
      },
    },
    {
      id: 'users',
      label: 'Users',
      icon: 'ri-group-line',
      link: '/#',
      click: function (e) {
        e.preventDefault();
        setIsUsers(!isUsers);
        setIsCurrentState('Users');
      },
      stateVariables: isUsers,
      subItems: [
        {
          id: "users-list",
          label: "Users",
          link: "/users",
          parentId: "users",
        },
        {
          id: 'admins',
          label: 'admins',
          link: '/admins',
          parentId: 'users',
        },
        {
          id: 'agents',
          label: 'Agents',
          link: '/agents',
          parentId: 'users',
        },
      ],
    },
    {
      id: 'sellers',
      label: 'Sellers',
      icon: 'ri-shopping-bag-3-line',
      link: '/sellers',
      click: function (e) {
        e.preventDefault();
        setIsCurrentState('Sellers');
      },
    },
    {
      id: 'terminals',
      label: 'Terminals',
      icon: 'ri-hard-drive-3-line',
      link: '/terminals',
      click: function (e) {
        e.preventDefault();
        setIsCurrentState('Terminals');
      },
    },
    {
      id: 'transactions',
      label: 'Sverka',
      icon: 'ri-swap-box-line',
      link: '/transactions',
      click: function (e) {
        e.preventDefault();
        setIsCurrentState('Transactions');
      },
    },
    {
      id: 'seller-transactions',
      label: 'Seller Transactions',
      icon: 'ri-swap-line',
      link: '/seller-transactions',
      click: function (e) {
        e.preventDefault();
        setIsCurrentState('SellerTransactions');
      },
    },
    {
      id: 'card-transactions',
      label: 'Card Transactions',
      icon: 'ri-bank-card-line',
      link: '/card-transactions',
      click: function (e) {
        e.preventDefault();
        setIsCurrentState('CardTransactions');
      },
    },
    {
      id: 'regions',
      label: 'Regions',
      icon: 'ri-global-line',
      link: '/regions',
      click: function (e) {
        e.preventDefault();
        setIsCurrentState('Regions');
      },
    },
    {
      id: 'bazaars',
      label: 'Bazaars',
      icon: 'ri-store-2-line',
      link: '/bazaars',
      click: function (e) {
        e.preventDefault();
        setIsCurrentState('Bazaars');
      },
    },
    {
      id: 'categories',
      label: 'Categories',
      icon: 'ri-list-check-2',
      link: '/categories',
      click: function (e) {
        e.preventDefault();
        setIsCurrentState('Categories');
      },
    },
    {
      id: 'products',
      label: 'Products',
      icon: 'ri-shopping-basket-2-line',
      link: '/products',
      click: function (e) {
        e.preventDefault();
        setIsCurrentState('Products');
      },
    },
    {
      id: 'settings',
      label: 'Settings',
      icon: 'ri-settings-4-line',
      link: '/settings',
      click: function (e) {
        e.preventDefault();
        setIsCurrentState('Settings');
      },
    },
  ];
  return <>{menuItems}</>;
};
export default Navdata;
